/**
 * Created by maple on 17/3/12.
 */

import {os, webviewInfo as webview, native, log as Log} from '@ali/amap-lib';
export default {

  /**
   * 生成schema
   * @param url {string} 需要在amap里打开的url\schema
   * @param noCommon {Boolean} 是否针对安卓ios使用不同协议iosamap、androidamap，默认false使用通用协议amapuri
   * @param hideTitleBar {Boolean} 是否隐藏titlebar，默认false不隐藏
   * @returns {string}
   */
  getSchema(url, noCommon, hideTitleBar) {
    noCommon = noCommon ? true : false;
    var type = 'amapuri';
    // 检查是否schema
    var isSchema = /^(?:(?:ios|android)amap|amapuri):\/\//i.test(url);
    if (isSchema) {
      return /^(?:(?:ios|android)amap|amapuri)(:\/\/.*)$/i.exec(url)[0];
    }
    if (noCommon) {
      var _os = os.ios ? 'ios' : 'android';
      type = _os + 'amap';
    }
    return type + '://openFeature?featureName=OpenURL&sa=1&sourceApplication=banner' +
      '&url=' + encodeURIComponent(url) + '&urlType=0&contentType=autonavi' + (hideTitleBar ? '&hide_title=1' : '');
  },
  /**
   * 生成通用呼起页面的地址
   * @param url {string} 需要在amap里打开的url\schema
   * @param noCommon {Boolean} 是否针对安卓ios使用不同协议iosamap、androidamap，默认false使用通用协议amapuri
   * @param hideTitleBar {Boolean} 是否隐藏titlebar，默认false不隐藏
   * @returns {string} 通用呼起页面的地址
   */
  getCallNative(url, noCommon, hideTitleBar) {
    noCommon = noCommon ? true : false;//当客户端没有在后台运行时呼起有bug(现象：不会打开活动页面) 建议true
    var _url = '';
    // var _callUrl = 'http://wap.amap.com/callnative/?';
    var _callUrl = 'http://cache.gaode.com/activity/openamap/index.html?';
    _url = _callUrl +
      'schema=' + encodeURIComponent(this.getSchema(url, noCommon, hideTitleBar)) +
      '&title=高德地图&whiteList=amap.com';
    return _url;
  },
  /**
   * 呼起高德地图并在端内打开指定页面且需要一键呼起
   * @param {Object} dom 呼起按钮（呼起按钮（$dom对象，如 $('.openbtn')，必须为a标签，且只能呼起release版高德地图）
   * @param {String} url 要打开页面的url\schema
   * @param {String} clicklog 该埋点的click值
   * @param hideTitleBar {Boolean} 是否隐藏titlebar，默认false不隐藏
   * @param type {String}  [非必传]渠道号:为满足wap站分渠道检测数据需求
   */
  openApp (dom, url, clicklog, hideTitleBar, type) {
    if (!clicklog) clicklog = "goamap";

    if (webview.isInAmap()) {//在端内
      dom.on('click', () => {
        Log.logJump(() => {
          if (!os.ios) native.destroyRightButton();//清除右上角btn
          location.href = url;
        }, clicklog);
      });
    } else {
      let _scheme = this.getCallNative(url, true, hideTitleBar);
      if (type) {
        _scheme += ('&type=' + type);
      }
      let $element = $('<a id="amapOpenApp" href="' + _scheme + '" style="display:none;"/>');
      $('body').append($element);
      // dom.on('click', function () {
      //     Log.logJump(function(){
      $('#amapOpenApp').trigger('click');
      //     },clicklog);
      // });
    }
  }
};
